export type ImageFile = string | ArrayBuffer;

export type ImageBase64String = string;
export type ImageSVGString = string;

export enum ImageAspectRatio {
	Free = 0,
	Square = 1,
	Ratio4by3 = 4 / 3,
	Ratio16by9 = 16 / 9,
	Banner = 7,
	Logo = 3.5,
}

export enum ImageShape {
	Rectangular,
	Circlular,
}

export interface IImageSpecification {
	key: string;
	title: string;
	shape: ImageShape;
	aspectRatio: ImageAspectRatio;
	minimumWidth?: number;
	allowedExtensions: string[];
}
